import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';

@observer
class CoffeeQuickRate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            score: null,
            aroma: null,
            acidity: null,
            sweetness: null,
            body: null,
            flavorRating: null,
            notes: '',
        };
    }

    componentDidMount() {
        const { coffeeStore } = this.props.stores;
        const { coffee = {} } = coffeeStore;

        this.setState({
            score: coffee.score || null,
            aroma: coffee.aroma || null,
            acidity: coffee.acidity || null,
            sweetness: coffee.sweetness || null,
            body: coffee.body || null,
            flavorRating: coffee.flavorRating || null,
            notes: coffee.notes || '',
        });
    }

    setRating = (field, value) => {
        this.setState({ [field]: value });
    }

    saveRatings = async () => {
        const { coffeeStore, appState } = this.props.stores;
        const { coffee = {} } = coffeeStore;
        const { callback } = this.props;
        const { score, aroma, acidity, sweetness, body, flavorRating, notes } = this.state;

        // Save each field
        if (score !== null) await coffeeStore.saveField(coffee.id, 'score', score);
        if (aroma !== null) await coffeeStore.saveField(coffee.id, 'aroma', aroma);
        if (acidity !== null) await coffeeStore.saveField(coffee.id, 'acidity', acidity);
        if (sweetness !== null) await coffeeStore.saveField(coffee.id, 'sweetness', sweetness);
        if (body !== null) await coffeeStore.saveField(coffee.id, 'body', body);
        if (flavorRating !== null) await coffeeStore.saveField(coffee.id, 'flavorRating', flavorRating);
        if (notes) await coffeeStore.saveField(coffee.id, 'notes', notes);

        if (callback) {
            callback();
        }
        appState.toggleDrawer();
    }

    renderStarRating = (field, label, value) => {
        const stars = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        return (
            <div class='mb-3'>
                <label class='form-label d-flex justify-content-between'>
                    <span>{label}</span>
                    <span class='badge bg-warning text-dark'>{value || '-'}/10</span>
                </label>
                <div class='d-flex justify-content-between'>
                    {stars.map(star => (
                        <button
                            key={star}
                            type='button'
                            class={`btn btn-sm ${value >= star ? 'btn-warning' : 'btn-outline-secondary'}`}
                            style='width: 9%; height: 32px; padding: 0;'
                            onClick={() => this.setRating(field, star)}
                        >
                            {star}
                        </button>
                    ))}
                </div>
            </div>
        );
    }

    render() {
        const { coffeeStore } = this.props.stores;
        const { coffee = {} } = coffeeStore;
        const { score, aroma, acidity, sweetness, body, flavorRating, notes } = this.state;

        const image = coffee.images?.[0];
        const imageUrl = image?.s3MediumLink || image?.s3Link;

        return (
            <div class='coffee-quick-rate'>
                <div class='w-100 d-flex justify-content-center'>
                    <div class='w-100' style='max-width: 600px; padding: 20px; padding-bottom: 100px;'>

                        {/* Coffee Info Header */}
                        <div class='card mb-4'>
                            <div class='row g-0'>
                                {imageUrl && (
                                    <div class='col-3'>
                                        <img
                                            src={imageUrl}
                                            class='img-fluid rounded-start h-100'
                                            style='object-fit: cover; max-height: 120px;'
                                            alt={coffee.name}
                                        />
                                    </div>
                                )}
                                <div class={imageUrl ? 'col-9' : 'col-12'}>
                                    <div class='card-body py-2'>
                                        <h5 class='card-title mb-1'>{coffee.name}</h5>
                                        <p class='card-text small text-muted mb-0'>
                                            <i class='fa-solid fa-globe me-1' />
                                            {coffee.country}
                                            {coffee.location && ` - ${coffee.location}`}
                                        </p>
                                        <p class='card-text small text-muted mb-0'>
                                            <i class='fa-solid fa-fire me-1' />
                                            {coffee.roastery}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Overall Score */}
                        <div class='card mb-4 border-warning'>
                            <div class='card-header bg-warning text-dark'>
                                <h6 class='mb-0'>
                                    <i class='fa-solid fa-star me-2' />
                                    Overall Score
                                </h6>
                            </div>
                            <div class='card-body'>
                                {this.renderStarRating('score', 'Your Rating', score)}
                            </div>
                        </div>

                        {/* Tasting Notes */}
                        <div class='card mb-4'>
                            <div class='card-header'>
                                <h6 class='mb-0'>
                                    <i class='fa-solid fa-wine-glass me-2' />
                                    Tasting Notes
                                </h6>
                            </div>
                            <div class='card-body'>
                                {this.renderStarRating('aroma', 'Aroma', aroma)}
                                {this.renderStarRating('acidity', 'Acidity', acidity)}
                                {this.renderStarRating('sweetness', 'Sweetness', sweetness)}
                                {this.renderStarRating('body', 'Body', body)}
                                {this.renderStarRating('flavorRating', 'Flavor', flavorRating)}
                            </div>
                        </div>

                        {/* Personal Notes */}
                        <div class='card mb-4'>
                            <div class='card-header'>
                                <h6 class='mb-0'>
                                    <i class='fa-solid fa-pen me-2' />
                                    Personal Notes
                                </h6>
                            </div>
                            <div class='card-body'>
                                <textarea
                                    class='form-control'
                                    rows='3'
                                    placeholder='Your tasting notes...'
                                    value={notes}
                                    onInput={(e) => this.setState({ notes: e.target.value })}
                                />
                            </div>
                        </div>

                    </div>
                </div>

                {/* Save Button */}
                <div class='w-100 d-flex flex-column justify-content-start px-4 py-3 bg-light fixed-bottom' style='bottom: 0; left: 0;'>
                    <button
                        class='btn btn-warning btn-lg w-100 rounded-pill'
                        onClick={this.saveRatings}
                    >
                        <i class='fa-solid fa-check me-2' />
                        Save Rating
                    </button>
                </div>
            </div>
        );
    }
}

export default CoffeeQuickRate;
